import { gql } from '@apollo/client';
const GET_MODEL_SPECIFICATION_AVERAGE_VARIANT_COST_DETAILS = gql `
  query GetModelSpecificationAverageVariantCostDetails($modelSpecificationId: ID!) {
    node(id: $modelSpecificationId) {
      ... on ModelSpecificationNode {
        id
        componentVariantAverageCostSummaries {
          id
          component {
            id
            name
            productCategory {
              id
              precision
            }
            productSnapshot {
              id
              product {
                id
              }
            }
          }
          colorsSizes {
            color
            size
          }
          consumptionValue
          consumptionType {
            id
            name
            labelPL
            labelEN
            integerValues
          }
          costInSpecificationCurrency
          unitCost
        }
        additionalCostSummaries {
          id
          name
          cost {
            value
            currencyIsoCode
          }
          exchangeRate
          costInSpecificationCurrency
        }
      }
    }
  }
`;
export default GET_MODEL_SPECIFICATION_AVERAGE_VARIANT_COST_DETAILS;
